module.exports = __webpack_public_path__ + "img/promo-jul-2020.bca4107e.jpeg";